module.exports = __webpack_public_path__ + "static/media/activity-managemencrm.f63ca379.svg";